// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choose-subscription-workflow-step .choose-subscription-form{text-align:left}", ""]);
// Exports
module.exports = exports;
